import { useState } from "react";
import ConditionalRender from "../../helpers/ConditionalRender";
import dayjs from "dayjs";

const AnalysePeriod = ({ cell, timezone }: { cell: any; timezone?: string }) => {
    const [selectedInterval, setSelectedInterval] = useState('15 min');
    const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    function getRedirectLink(values: any, isActivity: boolean) {
        // Convert selectedInterval to dayjs duration
        const intervalMapping: Record<string, number> = {
            '15 min': 15,
            '30 min': 30,
            '1 hour': 60,
            '2 hours': 120,
        };
        const intervalInMinutes = intervalMapping[selectedInterval] || 60; // Default to 1 hour if not provided

        let link = isActivity ? '/reports/activity-comparison?' : '/reports/sql-stats-comparison?';
        const instanceId = values.instanceId;

        // Parse timeslice in the user's selected timezone (API returns times in that timezone)
        const timeslice = tz === 'UTC' ? dayjs.utc(values.timeslice) : dayjs.tz(values.timeslice, tz);

        const firstInstanceTo = timeslice.toISOString();
        const firstInstanceFrom = timeslice.subtract(intervalInMinutes, 'minutes').toISOString();
        const secondInstanceFrom = timeslice.toISOString();
        const secondInstanceTo = timeslice.add(intervalInMinutes, 'minutes').toISOString();

        link += `chart=column&firstInstanceFrom=${firstInstanceFrom}&firstInstanceId=${instanceId}&firstInstanceTo=${firstInstanceTo}&metric=duration&other=false&secondInstanceFrom=${secondInstanceFrom}&secondInstanceId=${instanceId}&secondInstanceTo=${secondInstanceTo}&showSqlId=false&topN=20&generate=true`;
        return link;
    }

    const updateInterval = (action: 'increment' | 'decrement') => {
        const intervals = ['15 min', '30 min', '1 hour', '2 hours'];
        const currentIndex = intervals.indexOf(selectedInterval);

        if (action === 'increment' && currentIndex < intervals.length - 1) {
            setSelectedInterval(intervals[currentIndex + 1]);
        } else if (action === 'decrement' && currentIndex > 0) {
            setSelectedInterval(intervals[currentIndex - 1]);
        }
    };

    return (
        <>
            <ConditionalRender if={!cell.row.values.isHost}>
                <div className="dropdown">
                    <button
                        className="btn info-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="fa-regular fa-magnifying-glass-chart"></i>
                    </button>

                    <ul className="dropdown-menu shadow-sm border" aria-labelledby="dropdownMenuButton">
                        <li>
                            <div>
                                {/* Interval Selection */}
                                <div
                                    className="d-flex align-items-center justify-content-between px-2 py-1 border-bottom"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => updateInterval('decrement')}
                                        disabled={selectedInterval === '15 min'}
                                    >
                                        <i className="fa-solid fa-minus m-0"></i>
                                    </button>
                                    <span className="mx-2 no-select">{selectedInterval}</span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => updateInterval('increment')}
                                        disabled={selectedInterval === '2 hours'}
                                    >
                                        <i className="fa-solid fa-plus m-0"></i>
                                    </button>
                                </div>
                            </div>
                        </li>
                        <li className="border-bottom p-1">
                            <a
                                className="dropdown-item no-select"
                                target="_blank"
                                rel="noreferrer"
                                href={getRedirectLink(cell.row.values, true)}
                            >
                                Activity
                            </a>
                        </li>
                        <li className="p-1">
                            <a
                                className="dropdown-item no-select"
                                target="_blank"
                                rel="noreferrer"
                                href={getRedirectLink(cell.row.values, false)}
                            >
                                SQL Statistics
                            </a>
                        </li>
                    </ul>
                </div>
            </ConditionalRender>
        </>
    );
};


export default AnalysePeriod;
